module.exports = __webpack_public_path__ + "img/creative-landing.c98b48d3.png";